import { PlayerMetricHeuristic } from '../../jscaip/AI/PlayerMetricHeuristic';
import { PlayerNumberTable } from '../../jscaip/PlayerNumberTable';
export class ApagosRightmostHeuristic extends PlayerMetricHeuristic {
    getMetrics(node, _config) {
        const board = node.gameState.board;
        const size = board.length;
        const levelThreeDominant = board[size - 1].getDominatingPlayer();
        const result = PlayerNumberTable.of([0], [0]);
        if (levelThreeDominant.isPlayer()) {
            result.add(levelThreeDominant, 0, 1);
        }
        return result;
    }
}
